import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { ComponentSlider } from '../../../models/components/slider'
import QuoteSlider from '../quote/subcomponents/quoteSlider'
import VerticalTabsSlider from '../verticalTab'

type Props = {
  data: ComponentSlider
}

const SliderComponent: FC<Props> = ({ data }) => {
  if (!data || !data?.panels?.length) return null
  const useCase = data.useCase || 'Quote'

  let component
  switch (useCase) {
    case 'Vertical Tabs':
      component = <VerticalTabsSlider data={data} />
      break
    default:
      component = <QuoteSlider data={data} />
  }

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
      </Helmet>
      {component}
    </>
  )
}

export default SliderComponent
